/* ============================================================
   uxpeak — Design System JS
   Shared behavior: mobile menu, scroll bar, nav scrolled state,
   and the .rv reveal observer.
   Include on every page right before </body>:
     <script src="uxpeak-design-system.js"></script>
   Works with the markup in uxpeak-components.html.
   ============================================================ */

(function(){
  /* ── Mobile menu ── */
  function toggleMenu(){
    const h=document.getElementById('hamburger');
    const m=document.getElementById('mobMenu');
    if(!h||!m) return;
    const willOpen=!m.classList.contains('open');
    if(willOpen){
      document.documentElement.style.setProperty('--scroll-y','-'+window.scrollY+'px');
      m.classList.add('open');
      h.classList.add('open');
      document.body.classList.add('menu-open');
    } else {
      _closeMenu(h,m);
    }
  }
  function _closeMenu(h,m){
    const scrollY=document.body.style.top||document.documentElement.style.getPropertyValue('--scroll-y')||'0';
    m.classList.remove('open');
    h.classList.remove('open');
    document.body.classList.remove('menu-open');
    window.scrollTo(0,parseInt(scrollY)*-1);
  }
  function closeMenu(){
    const h=document.getElementById('hamburger');
    const m=document.getElementById('mobMenu');
    if(!h||!m) return;
    _closeMenu(h,m);
  }
  // expose globally so inline onclick="toggleMenu()" works
  window.toggleMenu=toggleMenu;
  window.closeMenu=closeMenu;
  document.addEventListener('keydown',(e)=>{if(e.key==='Escape')closeMenu()});

  /* ── Scroll progress bar + nav scrolled state ── */
  const bar=document.getElementById('scrollBar');
  const nav=document.getElementById('nav');
  if(bar||nav){
    window.addEventListener('scroll',()=>{
      const sc=window.scrollY;
      if(bar){
        const h=document.documentElement.scrollHeight-window.innerHeight;
        bar.style.width=(h>0?(sc/h*100):0)+'%';
      }
      // Nav scroll state disabled — causes jitter on mobile. Nav styling is static.
    },{passive:true});
  }

  /* ── Reveal on scroll ── */
  if('IntersectionObserver' in window){
    const io=new IntersectionObserver((es)=>{
      es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('vis');io.unobserve(e.target)}});
    },{threshold:.08,rootMargin:'0px 0px -40px 0px'});
    document.querySelectorAll('.rv').forEach(el=>io.observe(el));
    // Expose helper for dynamically-created rv elements
    window.uxReveal = el => { if(el && el.classList) io.observe(el); };
  } else {
    document.querySelectorAll('.rv').forEach(el=>el.classList.add('vis'));
    window.uxReveal = el => { if(el && el.classList) el.classList.add('vis'); };
  }

  /* ── Cursor halo ──
     Adds a soft violet ring that follows the native browser cursor
     (the native cursor stays visible — arrow / hand / I-beam still work).
     Skipped on touch devices and when reduced motion is preferred.
     Pairs with the .cursor-halo styles in uxpeak-design-system.css.
  */
  (function initCursor(){
    // Skip on touch / coarse pointer
    if(window.matchMedia && window.matchMedia('(pointer:coarse)').matches) return;
    // Skip if reduced motion is preferred
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    // Skip on small screens (matches CSS breakpoint)
    if(window.innerWidth < 901) return;

    const halo = document.createElement('div');
    halo.className = 'cursor-halo';
    document.body.appendChild(halo);

    let mx=window.innerWidth/2, my=window.innerHeight/2;
    let hx=mx, hy=my;

    document.addEventListener('mousemove', e => {
      mx=e.clientX; my=e.clientY;
    },{passive:true});

    function tick(){
      hx += (mx-hx)*0.18;
      hy += (my-hy)*0.18;
      halo.style.transform = `translate(${hx}px, ${hy}px) translate(-50%,-50%)`;
      requestAnimationFrame(tick);
    }
    tick();

    // Hover state on interactive elements
    const hoverSelector='a, button, .cta, .stat-card, .ft-card, .rv-card, .faq-item, [onclick], [role="button"], input, textarea, select, summary, label';
    function bindHover(el){
      el.addEventListener('mouseenter', ()=>document.body.classList.add('hovering'));
      el.addEventListener('mouseleave', ()=>document.body.classList.remove('hovering'));
    }
    document.querySelectorAll(hoverSelector).forEach(bindHover);

    // Watch for dynamically-added interactive elements
    if('MutationObserver' in window){
      const mo=new MutationObserver(muts=>{
        muts.forEach(m=>{
          m.addedNodes.forEach(n=>{
            if(n.nodeType!==1) return;
            if(n.matches && n.matches(hoverSelector)) bindHover(n);
            if(n.querySelectorAll) n.querySelectorAll(hoverSelector).forEach(bindHover);
          });
        });
      });
      mo.observe(document.body,{childList:true,subtree:true});
    }

    // Click state
    document.addEventListener('mousedown',()=>document.body.classList.add('clicking'));
    document.addEventListener('mouseup',  ()=>document.body.classList.remove('clicking'));

    // Hide when mouse leaves the window, show when it returns
    document.addEventListener('mouseleave',()=>{halo.style.opacity='0'});
    document.addEventListener('mouseenter',()=>{halo.style.opacity=''});
  })();
})();
